import React from 'react'
import Header from '../components/Header/Header'
import Navbar from '../components/Navbar/Navbar'

const PastConferences = () => {
    const conferences = [
        {
          year: "2024",
          description: "The 51st annual meeting of the Indian Immunology Society was held in IISc, Bangalore, from 17th to 20th Oct 2024. Dr. Dipankar Nandi led the organizing team of Immunocon-2024."
        },
        {
          year: "2023",
          description: "The Golden Jubilee Conference of the Immunology Society of India was held from 5th to 8th October 2023 at JL Auditorium, AIIMS New Delhi. The conference was organized by Dr. Uma Kanga [Convenor] and Dr. Sujata Mohanty [Co-convenor]."
        },
        {
          year: "2022",
          description: "The 49th Annual Conference of Indian Immunology Society (Immunocon-2022) was held at Post Graduate Institute of Medical Education and Research, Chandigarh, from 24-26th Nov. 2022. The conference was organized by Prof. Sunil Arora [Chair] and Dr. Gaurav Sharma [Convenor]."
        },
        {
          year: "2021",
          description: "The 48th Annual Scientific Meeting of the Indian Immunology Society was organized by Dr. Geeta Rai at Banaras Hindu University from 8th -9th July 2022 in Virtual Mode. "
        },
      ];
  return (
    <div>
      <Header />
      <Navbar />
      <div className="bg-gray-50 p-8 rounded-md">
      <h2 className="text-3xl mb-6">Past Immunocon Conferences</h2>
      <div className="space-y-6">
        {conferences.map((conf, index) => (
          <div key={index} className="border-l-4 border-blue-500 rounded pl-4">
            <h3 className="text-xl font-semibold text-gray-800 mb-2 ml-2">
              Immunocon-{conf.year}:
            </h3>
            <p className="text-gray-700 ml-2 font-medium">
              {conf.description}
            </p>
          </div>
        ))}
      </div>
    </div>
    </div>
  )
}

export default PastConferences
